import { render, staticRenderFns } from "./InsureSignNew.vue?vue&type=template&id=bbcd71d8&"
import script from "./InsureSignNew.vue?vue&type=script&lang=js&"
export * from "./InsureSignNew.vue?vue&type=script&lang=js&"
import style0 from "./InsureSignNew.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports